import styled from '@emotion/styled'

export const CardContainer = styled.div<{
  color?: string
  width?: string
  height?: string
  bgColor: string
  bgGradient: string
  hover: boolean
  margin?: string
}>`
  color: rgba(23, 29, 34, 0.87);
  width: ${({ width }) => (width ? width : 'auto')};
  height: ${({ height }) => (height ? height : 'auto')};
  background-image: ${({ bgGradient }) => (bgGradient ? bgGradient : 'none')};
  background-color: #fff;
  border-radius: 0.4rem;
  overflow: hidden;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: 0.2s;
  ${({ hover }) =>
    hover &&
    `
      &:hover {
        transform: translateY(-.5%);
        box-shadow: 0 4px 8px rgba(0, 0, 0, .2);
      }
  `}
  margin:${props => (props.margin ? props.margin : '0')};
`
